export default "<div [attr.size]=\"size\">\r\n  <div loader [attr.color]=\"color\"></div>\r\n</div>";